import Qs from 'qs'
import FetchFactory from '../factory'

interface ICompany {
  params: {
    company_slug: string
  }
}

interface ICompanyJobs {
  query: {
    filter: {
      search: string
      location_id: number
      category_id: string
      job_type_id: string
      jlpt_level: string
      is_jft_required: string
      minimum_salary: string
      maximum_salary: string
      date_posted: string
    }
    page: number
  }
  params: { company_slug: string }
}

class CompanyModule extends FetchFactory<any> {
    async getCompany(payload: ICompany) {
        const { params } = payload

        return await useAsyncData(() => {
            return super.call(
                `/api/job-seeker/companies/${params.company_slug}`,
                {
                    method: 'GET',
                },
      )
        })
    }

    async getCompanyGalleries(payload: ICompany) {
        const { params } = payload

        return await useAsyncData(() => {
            return super.call(
                `/api/job-seeker/companies/${params.company_slug}/galleries`,
                {
                    method: 'GET',
                },
      )
        })
    }

    async getCompanyJobs(payload: ICompanyJobs) {
        const { query, params } = payload

        return await useAsyncData(() => {
            return super.call(
                `/api/job-seeker/companies/${
                    params.company_slug
                }/jobs?${Qs.stringify(query)}`,
                {
                    method: 'GET',
                },
      )
        })
    }

    async getCompanyOverview(payload: IJob) {
        const { params } = payload

        return await useAsyncData(() => {
            return super.call(
                `/api/job-seeker/jobs/${params.job_slug}/company`,
                {
                    method: 'GET',
                },
      )
        })
    }

    async getSimilarJobs(payload: IJob) {
        const { params } = payload

        return await useAsyncData(() => {
            return super.call(
                `/api/job-seeker/jobs/${params.job_slug}/similar`,
                {
                    method: 'GET',
                },
      )
        })
    }

    async savedJob(payload: IJobSaved) {
        const { body } = payload

        return await useAsyncData(() => {
            return super.call('/api/job-seeker/jobs/bookmark', {
                method: 'POST',
                body
            })
        })
    }

    async getQuestions(payload: IJob) {
        const { params } = payload

        return await useAsyncData(() => {
            return super.call(
                `/api/job-seeker/jobs/${params.job_slug}/questions`,
                {
                    method: 'get',
                },
      )
        })
    }

    async applyJob(payload: IJobApply) {
        const { body, params } = payload

        return await useAsyncData(() => {
            return super.call(`/api/job-seeker/jobs/${params.job_slug}/apply`, {
                method: 'POST',
                body
            })
        })
    }
}

export default CompanyModule
